"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sequenceSVG = sequenceSVG;
const appendInternals_1 = require("./appendInternals");
const appendResidues_1 = require("./appendResidues");
const appendResiduesPosition_1 = require("./appendResiduesPosition");
const appendResults_1 = require("./appendResults");
const appendRows_1 = require("./appendRows");
const appendRowsInformation_1 = require("./appendRowsInformation");
const addCSS_1 = require("./draw/addCSS");
const addScript_1 = require("./draw/addScript");
const drawInternals_1 = require("./draw/drawInternals");
const drawReplacements_1 = require("./draw/drawReplacements");
const drawSequence_1 = require("./draw/drawSequence");
const getPaper_1 = require("./getPaper");
/**
 *
 * @param {string} sequence
 * @param {array} analysisResults
 * @param {object} [options={}]
 * @param {number} [options.leftRightBorders=50]
 * @param {number} [options.width=600]
 * @param {number} [options.spaceBetweenResidues=30]
 * @param {number} [options.spaceBetweenInternalLines=12]
 * @param {number} [options.strokeWidth=2]
 * @param {string} [options.labelFontFamily='Verdana']
 * @param {number} [options.labelSize=8]
 * @param {number} [options.parsing] Sequence parsing options
 * @param {object} [options.merge={}]
 * @param {boolean} [options.merge.charge] Merge results if only differs by charge
 * @param {object} [options.filter={}] define some filters
 * @param {number} [options.filter.minSimilarity=0]  minimal similarity
 * @param {number} [options.filter.minQuantity=0]  minimal quantity
 * @param {number} [options.filter.minRelativeQuantity=0]  minimal relative quantity. This value should be between 0 and 1 and supersede minQuantity.
 * @param {boolean} [options.filter.showInternals=true] show the internal fragments
 *
 */
function sequenceSVG(sequence, analysisResults, options = {}) {
    const { width = 600, leftRightBorders = 50, spaceBetweenResidues = 30, spaceBetweenInternalLines = 12, strokeWidth = 2, labelFontFamily = 'Verdana', labelSize = 8, parsing, merge, filter, } = options;
    const drawOptions = {
        spaceBetweenResidues,
        leftRightBorders,
        spaceBetweenInternalLines,
        strokeWidth,
        labelSize,
        labelFontFamily,
        verticalPosition: spaceBetweenInternalLines,
        width,
    };
    let data = {};
    (0, appendResidues_1.appendResidues)(data, sequence, parsing);
    (0, appendResults_1.appendResults)(data, analysisResults, {
        merge,
        filter,
    });
    (0, appendResiduesPosition_1.appendResiduesPosition)(data, {
        leftRightBorders,
        spaceBetweenResidues,
        labelFontFamily,
        labelSize,
        width,
    });
    (0, appendRows_1.appendRows)(data);
    (0, appendInternals_1.appendInternals)(data);
    (0, appendRowsInformation_1.appendRowsInformation)(data);
    // We start to create the SVG and create the paper
    const paper = (0, getPaper_1.getPaper)();
    (0, addCSS_1.addCSS)(paper);
    (0, addScript_1.addScript)(paper);
    for (let row of data.rows) {
        (0, drawInternals_1.drawInternals)(paper, row, drawOptions);
        (0, drawSequence_1.drawSequence)(paper, row, drawOptions);
    }
    (0, drawReplacements_1.drawReplacements)(paper, data, drawOptions);
    paper.size(width, drawOptions.verticalPosition);
    let svg = paper.svg();
    paper.clear();
    return svg;
}
//# sourceMappingURL=sequenceSVG.js.map